export default __webpack_public_path__ + "static/online-scheduling-28ed20c29bf3d5f0eb4c1d1e07e47f60.png";